import React, {Component} from "react";

import {Icon} from "@mui/material";

import env from "../../../env";

import Text from "../../components/Text";

import "./AndroidDownload.styl";

class AndroidDownload extends Component {
    render() {
        return (
            <div className={"android"}>
                <h1>Baixar aplicativo Android:</h1>
                <a href={env.apkUrl} download>
                    <Icon>android</Icon>
                    <Text>Download</Text>
                </a>
            </div>
        )
    }
}

export default AndroidDownload;
